import { render, staticRenderFns } from "./ScaleGuide.vue?vue&type=template&id=2d0a75dc&scoped=true&"
import script from "./ScaleGuide.vue?vue&type=script&lang=js&"
export * from "./ScaleGuide.vue?vue&type=script&lang=js&"
import style0 from "./ScaleGuide.vue?vue&type=style&index=0&id=2d0a75dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0a75dc",
  null
  
)

export default component.exports